import { IAssistanceCategoryState, IAssistanceSearchState, IAssistanceState, IAssistanceObject } from '../../../types'
import {
  IAssistanceAction,
  IAssistanceCategoryAction,
  IAssistanceCategoryCreateSuccess,
  IAssistanceCategoryListSuccess,
  IAssistanceCategoryRemoveFailure,
  IAssistanceCategoryRemoveRequest,
  IAssistanceCreateSuccess,
  IAssistanceListSuccess,
  IAssistanceRemoveFailure,
  IAssistanceRemoveRequest,
  IAssistanceSearchSuccess,
  IAssistanceUpdateSuccess,
  IAssistanceRemoveSuccess
} from '../../actions/assistance'
import {
  ASSISTANCE_CATEGORY_CREATE_FAILURE,
  ASSISTANCE_CATEGORY_CREATE_REQUEST,
  ASSISTANCE_CATEGORY_CREATE_SUCCESS,
  ASSISTANCE_CATEGORY_LIST_FAILURE,
  ASSISTANCE_CATEGORY_LIST_REQUEST,
  ASSISTANCE_CATEGORY_LIST_SUCCESS,
  ASSISTANCE_CATEGORY_REMOVE_FAILURE,
  ASSISTANCE_CATEGORY_REMOVE_REQUEST,
  ASSISTANCE_CATEGORY_REMOVE_SUCCESS,
  ASSISTANCE_CREATE_FAILURE,
  ASSISTANCE_CREATE_REQUEST,
  ASSISTANCE_CREATE_SUCCESS,
  ASSISTANCE_LIST_FAILURE,
  ASSISTANCE_LIST_REQUEST,
  ASSISTANCE_LIST_SUCCESS,
  ASSISTANCE_REMOVE_FAILURE,
  ASSISTANCE_REMOVE_REQUEST,
  ASSISTANCE_REMOVE_SUCCESS,
  ASSISTANCE_SEARCH_FAILURE,
  ASSISTANCE_SEARCH_REQUEST,
  ASSISTANCE_SEARCH_SUCCESS,
  CLEAR_ASSISTANCE_SEARCH,
  ASSISTANCE_UPDATE_REQUEST,
  ASSISTANCE_UPDATE_SUCCESS,
  ASSISTANCE_UPDATE_FAILURE
} from '../../constants/'

const initialState: any = {
  isFetching: false,
  items: {},
  lastUpdated: Date.now()
}

const initialSearchState: any = {
  isFetching: false,
  items: [],
  query: ''
}

const initialCategoryState: IAssistanceCategoryState = {
  isFetching: false,
  items: {},
  lastUpdated: Date.now()
}

export function assistances(state: IAssistanceState, action: IAssistanceAction): IAssistanceState {
  if (typeof state === 'undefined') {
    return initialState
  }
  switch (action.type) {
    case ASSISTANCE_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case ASSISTANCE_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: (action as IAssistanceListSuccess).assistances,
        lastUpdated: Date.now()
      })

    case ASSISTANCE_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })

    case ASSISTANCE_CREATE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })

    case ASSISTANCE_CREATE_SUCCESS: {
      const assistance: IAssistanceObject = (action as IAssistanceCreateSuccess).assistance
      const obj = Object.assign({}, state.items)
      obj[assistance.id] = assistance
      const copy = Object.assign({}, state, {
        isFetching: true,
        items: obj
      })
      return copy
    }
    case ASSISTANCE_CREATE_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    case ASSISTANCE_UPDATE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case ASSISTANCE_UPDATE_SUCCESS: {
      const opt: IAssistanceObject = (action as IAssistanceUpdateSuccess).assistance
      const obj = Object.assign({}, state.items)
      if (obj[opt.id]) {
        delete obj[opt.id]
      }
      obj[opt.id] = opt
      const copy = Object.assign({}, state, {
        isFetching: true,
        items: obj
      })
      return copy
    }
    case ASSISTANCE_UPDATE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })

    case ASSISTANCE_REMOVE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case ASSISTANCE_REMOVE_SUCCESS: {
      const opt: IAssistanceObject = (action as IAssistanceRemoveSuccess).assistance
      const obj = Object.assign({}, state.items)
      if (obj[opt.id]) {
        delete obj[opt.id]
      }
      const copy = Object.assign({}, state, {
        isFetching: true,
        items: obj
      })
      return copy
    }
    case ASSISTANCE_REMOVE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
  }
  return state
}

export function assistanceCategories(
  state: IAssistanceCategoryState,
  action: IAssistanceCategoryAction
): IAssistanceCategoryState {
  if (typeof state === 'undefined') {
    return initialCategoryState
  }
  switch (action.type) {
    case ASSISTANCE_CATEGORY_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case ASSISTANCE_CATEGORY_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: (action as IAssistanceCategoryListSuccess).assistances,
        lastUpdated: Date.now()
      })

    case ASSISTANCE_CATEGORY_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })

    // CREATE
    case ASSISTANCE_CATEGORY_CREATE_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case ASSISTANCE_CATEGORY_CREATE_SUCCESS:
      const category = (action as IAssistanceCategoryCreateSuccess).category
      const items = Object.assign({}, state.items)
      items[category.id] = Object.assign({}, category)
      return Object.assign({}, state, {
        isFetching: false,
        items
      })
    case ASSISTANCE_CATEGORY_CREATE_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    // REMOVE
    case ASSISTANCE_CATEGORY_REMOVE_REQUEST: {
      const category = (action as IAssistanceCategoryRemoveRequest).category
      const items = Object.assign({}, state.items)
      delete items[category.id]
      const copy = Object.assign({}, state, {
        isFetching: true,
        items
      })
      return copy
    }
    case ASSISTANCE_CATEGORY_REMOVE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false
      })
    case ASSISTANCE_CATEGORY_REMOVE_FAILURE: {
      const category = (action as IAssistanceCategoryRemoveFailure).category
      const items = Object.assign({}, state.items)
      items[category.id] = Object.assign({}, category)
      return Object.assign({}, state, {
        isFetching: false,
        items
      })
    }
  }
  return state
}

export function assistanceSearch(state: IAssistanceSearchState, action: any): IAssistanceSearchState {
  if (typeof state === 'undefined') {
    return initialSearchState
  }
  switch (action.type) {
    case ASSISTANCE_SEARCH_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        query: action.query
      })
    case ASSISTANCE_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: (action as IAssistanceSearchSuccess).assistances
      })
    case ASSISTANCE_SEARCH_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
    case CLEAR_ASSISTANCE_SEARCH:
      return Object.assign({}, state, {
        items: []
      })
  }
  return state
}



// WEBPACK FOOTER //
// ./src/state/reducers/assistance/index.ts